import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutOrderMoveStopsTableQuickInfo } from "./autogen/AutogenLayoutOrderMoveStopsTableQuickInfo";
import { DataDisplayEvent } from "@mcleod/components";

export class OrderMoveStopsTableQuickInfo extends AutogenLayoutOrderMoveStopsTableQuickInfo {

    /** This is an event handler for the onDataDisplay event of textboxMovementId. */
    textboxMovementIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxMovementId.printableLabel.link = LayoutUrl.create(
            "lme/dispatch/OrderTabView",
            {
                mode: "update",
                key: event.rowData?.get("curr_movement_id"),
                orderId: event.rowData?.get("id")
            }
        );
    }


    /** This is an event handler for the onDataDisplay event of textboxId. */
    textboxIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxId.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/dispatch/OrderTabView",
            event.rowData?.get("id")
        );
    }

}
